import * as types from "./mutation-types";

export const mutations = {
    [types.UPDATE_LOADING_FIRMAS](state, payload) {
        state.loadingFirmas = payload;
    },
    [types.UPDATE_ERROR_FIRMAS](state, payload) {
        state.errorFirmas = payload;
    },
    [types.UPDATE_FIRMAS](state, payload) {
        state.firmas = payload;
    }
}